<template>
  <div class="ia">
    <vue-select-image :dataImages="images" @onselectimage="onSelectImage">
    </vue-select-image>
    <b-button v-show="answered" type="is-info" @click="CheckAnswer()">Check answer</b-button>
    <b-notification
      :duration="2000"
      :type="correct ? 'is-success' : 'is-danger'"
      :active.sync="checked"
      aria-close-label="Close notification">
      {{ correct ? 'That is correct!':'This is not the correct selection. Try again.'  }}
      </b-notification>
  </div>
</template>

<script>
import { BNotification } from 'buefy/src/components/notification';
import { BButton } from 'buefy/src/components/button';
import VueSelectImage from "vue-select-image";
require("vue-select-image/dist/vue-select-image.css");

export default {
  name: "ImageSelect",
  props: {
    module
  },
  data() {
    return {
      loading: true,
      images: [],
      answered: false,
      answer: null,
      checked: false,
      correct: null,
    };
  },
  components: {
    VueSelectImage,
    BButton,
    BNotification
  },
  mounted() {
    this.whichImages();
  },
  
  methods: {
    CheckAnswer() {
      if (this.answer == 2) {
        this.correct = true;
      } else {
        this.correct = false;
      }
      this.checked = true;
      setTimeout(() => {
        this.checked = false;
      }, 2500);
    },
    whichImages() {
      switch (this.module) {
        case "3-5":
          this.images = [
            {
              id: "1",
              src: "https://scaleapi.designori.net/uploads/resorbed1_901f2b4ee7.png",
            },
            {
              id: "2",
              src: "/img/08-QU8603F005.jpg",
            },
            {
              id: "3",
              src: "https://scaleapi.designori.net/uploads/resorbed2_b684757146.png",
            }
          ];
          break;

        case "1-2":
          this.images = [
            {
              id: "1",
              src: "../../img/08-QU8603F005.jpg",
              alt: "Scale 1"
            },
            {
              id: "2",
              src: "../../img/14-NK8104M020.jpg",
              alt: "Scale 2"
            }
          ];
          break;

        default:
          break;
      }
    },
    onSelectImage(e) {
      this.answered = true;
      this.answer = e.id;
      console.log(
        "...saving answer ( " + e.id + " ) for imageselect, module: ",
        this.module 
      );
      //commit to step in progress state
      this.$emit("done", e);
    },
  },
  computed: {
    // module() {
    //   return this.$route.params.module + '-' + this.$route.params.step
    // }
  },
};
</script>

<style lang="scss">
.content {
  ul.vue-select-image__wrapper {
    list-style: none;
  }

  .ia {
    position: relative;
    padding: 10px;
  }

  .vue-select-image__thumbnail {
    width: 300px;
  }
}
</style>

